import { Injectable } from '@angular/core';
import { NEVER, Observable } from 'rxjs';
import { IOAuthPopupService } from '../o-auth/o-auth-popup-service';

@Injectable({
  providedIn: 'root'
})
export class OAuthPopupServiceMock implements IOAuthPopupService {
  openOrNavigateOAuthPopup(): void {
    return;
  }

  isNavigationInPopupPossible(): boolean {
    return false;
  }

  closedByUser(): Observable<unknown> {
    return NEVER;
  }

  close(): void {
    return;
  }
}
